module.exports = new __parcel__URL__("popup-image.c1b1bf07.svg").toString();